import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { AssetCollectionPublicViewClient, AssetCollectionPublicViewDTO, FileResponse } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class AssetCollectionPublicViewService {

  constructor(
    private publicViewClient: AssetCollectionPublicViewClient,
    private spinnerService: SpinnerService,
  ) {

  }

  public getAssetCollection(token: string): Observable<AssetCollectionPublicViewDTO> {
    this.spinnerService.show()
    return this.publicViewClient.getAssetCollectionByToken(token)
      .pipe(
        finalize(() => {
          this.spinnerService.hide();
        }
        ),
        catchError((error: any) => {
          return throwError(() => error);
        })
      );
  }

  public downloadAssets(collectionId: number, assetIds:number[]): Observable<FileResponse> {
    this.spinnerService.show();
    return this.publicViewClient.download(collectionId, assetIds)
      .pipe(
        finalize(() => {
          this.spinnerService.hide();
        }),
        catchError((error: any) => {
          return throwError(() => error);
        })
      );
  }
}
